module.exports = __webpack_public_path__ + "static/bg_tail-c3cf5349c250998f124b2e333dec4cb5.jpg";